var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3"},[_c('label',[_vm._v("Search Screens")]),_c('c-input',{attrs:{"type":"text","value":_vm.filters.search},on:{"input":_vm.updateSearch}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }